module.exports = __webpack_public_path__ + "static/img/idcard_sl4.91bb2c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/idcard_sl4.png
// module id = YMFO
// module chunks = 1